import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { BookingSummary } from '@/services/BookingService.interface'
import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'
import ReserveActionsModal from '@/components/common/ReserveActionsModal.vue'
import type { ReserveAction } from '@/utils/bookingFunnelNavigation'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReserveActionsButton',
  props: {
  booking: {
    type: Object as () => BookingSummary,
    required: true,
  },
  defaultLabel: {
    type: String,
    required: true,
  },
  buttonClass: {
    type: String,
    default: '',
  },
  rootClass: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const modalRef = ref<InstanceType<typeof ReserveActionsModal> | null>(null)

const bookingRef = () => props.booking
const {
  reserveActions,
  hasMultipleReserveActions,
  openReserveAction,
  openDefaultReserveAction,
} = useBookingFunnelNavigation(bookingRef)

const onSelectAction = async (action: ReserveAction) => {
  await openReserveAction(action)
}

const onMainButtonClick = async () => {
  if (reserveActions.value.length === 0) {
    console.error('Missing reserve navigation for booking', props.booking.reference)
    return
  }
  if (hasMultipleReserveActions.value) {
    modalRef.value?.open()
    return
  }
  await openDefaultReserveAction()
}

return (_ctx: any,_cache: any) => {
  return (_unref(reserveActions).length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["reserve-actions", __props.rootClass])
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["button-primary primary-normal small action-button", __props.buttonClass]),
          onClick: onMainButtonClick
        }, _toDisplayString(__props.defaultLabel), 3),
        _createVNode(ReserveActionsModal, {
          ref_key: "modalRef",
          ref: modalRef,
          actions: _unref(reserveActions),
          onSelect: onSelectAction
        }, null, 8, ["actions"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})